import type { AlertType } from './Alert';
import type { ButtonVariant } from './Button';
import type { ModalTrayTone } from './modalTray';

export type ConfirmationDialogVariant = 'default' | 'warning' | 'destructive' | 'success';

export interface ConfirmationDialogVariantStyle {
    badge: string;
    tray: ModalTrayTone;
    confirmVariant: ButtonVariant;
    calloutType: AlertType;
}

export const CONFIRMATION_DIALOG_VARIANTS: Record<
    ConfirmationDialogVariant,
    ConfirmationDialogVariantStyle
> = {
    default: {
        badge: 'var(--malachite-text-secondary)',
        tray: 'neutral',
        confirmVariant: 'filled',
        calloutType: 'info',
    },
    warning: {
        badge: 'var(--malachite-tag-warning-foreground)',
        tray: 'warning',
        confirmVariant: 'filled',
        calloutType: 'warning',
    },
    destructive: {
        badge: 'var(--malachite-tag-error-foreground)',
        tray: 'error',
        confirmVariant: 'destructive',
        calloutType: 'error',
    },
    success: {
        badge: 'var(--malachite-tag-success-foreground)',
        tray: 'success',
        confirmVariant: 'filled',
        calloutType: 'success',
    },
};
